<ng-container *ngFor="let subtask of subtasks; let i = index">
  <div class="col col-xs-12 col-sm-12 subtask-container">
    <div class="col col-xs-12 col-sm-12 col-md-4 column-title">
      <div class="title-inner-container">
        <div class="subtask-icon">
          <ng-container *ngIf="subtask.status === 'Completed'; else SubtaskIncomplete">
            <mat-icon class="subtask-completed">check</mat-icon>
          </ng-container>
          <ng-template #SubtaskIncomplete>
            <span class="subtask-incomplete">
              {{ (i + 1).toString() }}
            </span>
          </ng-template>
        </div>
        <div class="title-text">
          {{ subtask.title }}
        </div>
      </div>
    </div>
    <div class="col col-xs-12 col-sm-12 col-md-8 column-details">
      <div class="details-inner-container" [ngSwitch]="subtask.status">
        <div *ngSwitchCase="'Completed'" class="details-text">
          {{ 'PROJECT_TRACKER.COMPLETED_ON' | translate: { date: (subtask.completionDate | date: 'longDate') } }}
        </div>
        <div *ngSwitchCase="'In Progress'" class="details-text">
          <span class="status-in-progress">
            {{ 'PROJECT_TRACKER.IN_PROGRESS' | translate }}
          </span>
          <span>-</span>
          <ng-container
            [ngTemplateOutlet]="estimatedCompletion"
            [ngTemplateOutletContext]="{ dueDate: subtask.dueDate }"
          ></ng-container>
        </div>
        <div *ngSwitchCase="'Waiting on Customer'" class="details-text status-waiting-on-customer">
          {{ 'PROJECT_TRACKER.WAITING_ON_CUSTOMER' | translate }}
        </div>
        <div *ngSwitchDefault class="details-text">
          <ng-container
            [ngTemplateOutlet]="estimatedCompletion"
            [ngTemplateOutletContext]="{ dueDate: subtask.dueDate }"
          ></ng-container>
        </div>
        <div class="notes-container" *ngIf="subtask.notes || subtask.conversations?.length > 0">
          <div *ngIf="subtask.notes" markdown ngPreserveWhitespaces class="notes-text">
            {{ subtask.notes }}
          </div>
          <div class="notes-feedback" *ngFor="let feedback of subtask.conversations">
            <ng-container *ngIf="feedback?.isPublic && feedback?.message">
              <div
                *ngIf="feedback.source === 'smb' || feedback.persona === PersonaType.PERSONA_TYPE_SMB"
                class="notes-feedback-title"
              >
                {{ 'PROJECT_TRACKER.YOU_REQUESTED_REVISIONS' | translate: { title: subtask.title } }}
              </div>
              <div *ngIf="feedback.persona === PersonaType.PERSONA_TYPE_DIGITAL_AGENT" class="notes-feedback-title">
                {{ 'PROJECT_TRACKER.FULFILLMENT_TEAM_MESSAGE' | translate }}
              </div>
              <div
                *ngIf="
                  feedback.persona !== PersonaType.PERSONA_TYPE_DIGITAL_AGENT &&
                  feedback.persona !== PersonaType.PERSONA_TYPE_SMB
                "
                class="notes-feedback-title"
              >
                {{ 'PROJECT_TRACKER.GENERIC_MESSAGE' | translate }}
              </div>
              <div class="notes-feeback-content" [innerHTML]="feedback?.message"></div>
            </ng-container>
          </div>
        </div>

        @if (subtask.feedbackEnabled) {
          <div class="feedback-container">
            <form [formGroup]="subtask.form">
              @if (subtask.status !== COMPLETED_STATUS) {
                <glxy-form-field appearance="outline" class="feedback-textarea">
                  <glxy-label>
                    {{ 'PROJECT_TRACKER.PROVIDE_FEEDBACK' | translate }}
                  </glxy-label>
                  <textarea
                    matInput
                    [formGroup]="subtask.form"
                    [formControlName]="getFeedbackControlName(i)"
                    cdkTextareaAutosize
                    cdkAutosizeMaxRows="5"
                    cdkAutosizeMinRows="2"
                  ></textarea>
                </glxy-form-field>
                <div class="send-feedback-button-container">
                  <button
                    mat-stroked-button
                    class="feedback-approve"
                    (click)="saveFeedback(i)"
                    [disabled]="!subtask.form.get(getFeedbackControlName(i)).value"
                  >
                    <glxy-button-loading-indicator
                      [isLoading]="feedbackSaving()?.loading && feedbackSaving()?.index === i"
                    >
                      {{ 'PROJECT_TRACKER.SEND_FEEDBACK' | translate }}
                    </glxy-button-loading-indicator>
                  </button>
                </div>
              }

              <div class="files-title">{{ 'PROJECT_TRACKER.FILES' | translate }}</div>
              <div>{{ 'PROJECT_TRACKER.FILE_DISCLAIMER' | translate }}</div>

              @if (subtask.files?.length > 0) {
                <mat-list>
                  @for (
                    file of subtask.files | filterAndSortFulfillmentFiles: (userPersonaAsString$ | async);
                    track file
                  ) {
                    <mat-list-item>
                      <div class="attachments-list">
                        <div>
                          @if (
                            attachmentLoading()?.loading &&
                            attachmentLoading()?.index === $index &&
                            attachmentLoading()?.subtaskId === subtask.subtaskId
                          ) {
                            <glxy-loading-spinner [fullHeight]="true" [inline]="true"></glxy-loading-spinner>
                          } @else {
                            <mat-icon class="attachment-icon">attachment</mat-icon>
                          }
                          <a class="file-name" (click)="handleFileNameClicked(file, subtask, $index)">{{
                            file.name
                          }}</a>
                        </div>
                        <div class="attachments-right-content">
                          <span class="uploaded-by">{{ file | uploadedBy | translate }}</span>
                          @if (file | canDeleteFile: (userPersonaAsString$ | async)) {
                            @if (deleteAttachmentLoading()?.loading && deleteAttachmentLoading()?.index === $index) {
                              <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
                            } @else {
                              <button mat-icon-button (click)="handleFileDeleted(subtask, file, $index)">
                                <mat-icon>close</mat-icon>
                              </button>
                            }
                          } @else {
                            <div class="spacer"></div>
                          }
                        </div>
                      </div>
                    </mat-list-item>
                  }
                </mat-list>
              }

              @if (
                ((subtask.files | filterAndSortFulfillmentFiles: (userPersonaAsString$ | async))?.length || 0) < 10
              ) {
                <project-tracker-subtasks-uploader
                  [subtask]="subtask"
                  (fileUploaded)="handleFileUploaded($event, subtask)"
                  (fileUploadError)="handleFileUploadErrored($event)"
                ></project-tracker-subtasks-uploader>
              }
            </form>
            @if (subtask.approved) {
              <div class="approved-container">
                <div>
                  <mat-icon class="approved-icon">check</mat-icon>
                  {{ 'PROJECT_TRACKER.YOU_APPROVED' | translate: { title: subtask.title } }}
                </div>
                @if (subtask.status !== COMPLETED_STATUS) {
                  <button mat-stroked-button (click)="undoApproveTask(subtask)">
                    <glxy-button-loading-indicator
                      [isLoading]="undoApproveSaving()?.loading && undoApproveSaving()?.index === i"
                    >
                      {{ 'PROJECT_TRACKER.REOPEN_TASK' | translate }}
                    </glxy-button-loading-indicator>
                  </button>
                }
              </div>
            }
          </div>
        } @else {
          <!-- Feedback not enabled, but we still want to show public files uploaded by the Fulfillment Team if there are any -->
          @if (subtask.files?.length > 0) {
            <div class="feedback-container">
              <div class="files-title">{{ 'PROJECT_TRACKER.FILES' | translate }}</div>
              <mat-list>
                @for (
                  file of subtask.files | filterAndSortFulfillmentFiles: (userPersonaAsString$ | async);
                  track file
                ) {
                  <mat-list-item>
                    <div class="attachments-list">
                      <div>
                        @if (
                          attachmentLoading()?.loading &&
                          attachmentLoading()?.index === $index &&
                          attachmentLoading()?.subtaskId === subtask.subtaskId
                        ) {
                          <glxy-loading-spinner [fullHeight]="true" [inline]="true"></glxy-loading-spinner>
                        } @else {
                          <mat-icon class="attachment-icon">attachment</mat-icon>
                        }
                        <a class="file-name" (click)="handleFileNameClicked(file, subtask, $index)">{{ file.name }}</a>
                      </div>
                      <div class="attachments-right-content">
                        <span class="uploaded-by">{{ file | uploadedBy | translate }}</span>
                        <div class="spacer"></div>
                      </div>
                    </div>
                  </mat-list-item>
                }
              </mat-list>
            </div>
          }
        }

        <div *ngIf="subtask.feedbackEnabled" class="feedback-button-container">
          <div class="feedback-buttons">
            <button
              *ngIf="!subtask.approved"
              mat-flat-button
              color="accent"
              class="feedback-approve"
              (click)="approveTask(i)"
              [disabled]="subtask.approved"
            >
              <glxy-button-loading-indicator [isLoading]="approveSaving()?.loading && approveSaving()?.index === i">
                {{ 'PROJECT_TRACKER.APPROVE' | translate }}
              </glxy-button-loading-indicator>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #estimatedCompletion let-dueDate="dueDate">
  <span *ngIf="dueDate">
    {{ 'PROJECT_TRACKER.ESTIMATED_COMPLETION' | translate: { date: (dueDate | date: 'longDate') } }}
  </span>
</ng-template>
